import React, { useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { Title } from '../Attraction/Attraction.styles';
import ArticleCard, { ArticleCardProps } from './ArticleCard';
import styled from 'styled-components';

interface ArticlesListProps {
  title?: string;
  articles: ArticleCardProps[];
  rowProps?: { xs: number; md: number; lg: number };
}

const ActionButton = styled(Button)`
  margin: 2rem auto;
  display: block;
  background-color: ${({ theme }) => theme.colors.primary};
  border: none;
  padding: 0.5rem 2rem;
  font-size: 1.1rem;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

const ArticleCardsContainer: React.FC<ArticlesListProps> = ({
  title,
  articles,
  rowProps = { xs: 1, md: 2, lg: 3 },
}) => {
  const { xs, md, lg } = rowProps;
  const cardsPerRow = lg;
  const initialRows = 2;
  const initialCards = cardsPerRow * initialRows;

  const [displayedCards, setDisplayedCards] = useState(initialCards);

  const handleShowMore = () => {
    setDisplayedCards(articles.length);
  };

  const handleShowLess = () => {
    setDisplayedCards(initialCards);
    // Scroll to the top of the cards container smoothly
    window.scrollTo({ top: window.scrollY - 500, behavior: 'smooth' });
  };

  return (
    <>
      {title ? <Title>{title}</Title> : null}

      <Row xs={xs} md={md} lg={lg} className="g-4">
        {articles.slice(0, displayedCards).map((article) => (
          <Col key={article.slug}>
            <ArticleCard {...article} />
          </Col>
        ))}
      </Row>

      {displayedCards < articles.length ? (
        <ActionButton onClick={handleShowMore}>הצג עוד יעדים</ActionButton>
      ) : (
        articles.length > initialCards && (
          <ActionButton onClick={handleShowLess}>הצג פחות יעדים</ActionButton>
        )
      )}
    </>
  );
};

export default ArticleCardsContainer;
